import { Popover, PopoverProps } from 'antd';
import { ToolbarIcon } from '../../ToolbarIcon';
import stickersImage from './stickers.png';
import styled from '@emotion/styled';

function KwaiStickerPicker({
  onPick,
  ...otherProps
}: { onPick: (sticker: string) => void } & PopoverProps) {
  return (
    <Popover
      trigger="click"
      content={
        <Content>
          {stickers.map((sticker) => {
            const [x, y] = stickerPositionMap[sticker];
            return (
              <div key={sticker} onClick={() => onPick(sticker)}>
                <span style={{ backgroundPosition: `${x}px ${y}px` }} />
              </div>
            );
          })}
        </Content>
      }
      {...otherProps}
    >
      {otherProps.children || <ToolbarIcon icon="emoji" />}
    </Popover>
  );
}

const stickerPositionMap = {
  '[treacherous]': [-125, -125],
  '[grin]': [-176, -50],
  '[snort]': [0, -300],
  '[oh]': [-100, -225],
  '[smile]': [-226, -150],
  '[naughty]': [0, -200],
  '[stunned]': [-25, -200],
  '[starryeyed]': [-125, -275],
  '[curious]': [-301, -200],
  '[angry]': [-201, -75],
  '[sad]': [-301, -75],
  '[pout]': [-125, -200],
  '[surprised]': [-25, -300],
  '[shy]': [-200, -200],
  '[flirting]': [-226, 0],
  '[sweaty]': [-100, -300],
  '[vomit]': [-50, -50],
  '[sophisticated]': [-225, -250],
  '[helmet]': [-301, -275],
  '[cool]': [0, -175],
  '[laughcry]': [-125, -175],
  '[happy]': [0, 0],
  '[wronged]': [-201, 0],
  '[despise]': [0, -125],
  '[disdain]': [-150, -175],
  '[arranged]': [0, -250],
  '[follow]': [-126, -50],
  '[sister]': [-276, -125],
  '[brother]': [-100, -175],
  '[clap]': [-175, -200],
  '[yawn]': [-301, -250],
  '[curse]': [-151, -100],
  '[cry]': [-176, -150],
  '[celebrate]': [-101, -75],
  '[shutup]': [-176, -125],
  '[scared]': [0, -100],
  '[redface]': [-100, -125],
  '[kiss]': [-276, -200],
  '[awkward]': [-175, -225],
  '[dizzy]': [-251, -50],
  '[snicker]': [-251, -200],
  '[poor]': [0, -50],
  '[dignose]': [-200, -275],
  '[bye]': [-25, -100],
  '[pan]': [-50, -225],
  '[oops]': [-251, -100],
  '[boss]': [-201, -150],
  '[crazy]': [-150, -250],
  '[quiet]': [-75, -175],
  '[almostcry]': [-201, -50],
  '[skeleton]': [-25, -125],
  '[titter]': [-276, -225],
  '[tears]': [-76, -50],
  '[tease]': [-226, -100],
  '[sleepy]': [-75, -150],
  '[sleep]': [-225, -225],
  '[right]': [-301, 0],
  '[left]': [-201, -175],
  '[nosebleed]': [-50, -150],
  '[thigh]': [0, -150],
  '[sneak]': [-25.5, 0],
  '[eatmelon]': [-75, -100],
  '[what]': [-201, -25],
  '[rotate]': [-150, -150],
  '[simper]': [-176, -25],
  '[rainbow]': [-101, 0],
  '[wipenose]': [-25, -275],
  '[dirtytalk]': [-176, 0],
  '[please]': [-126, 0],
  '[fighting]': [-126, -75],
  '[sweat]': [-76, 0],
  '[wanttoeat]': [-251, -150],
  '[hitface]': [-225, -275],
  '[vomitblood]': [-151, -50],
  '[awkard]': [-75, -75],
  '[ghost]': [-50, -125],
  '[nostrils]': [-76, -25],
  '[boom]': [-226, -175],
  '[omg]': [-100, -275],
  '[fossil]': [-75, -225],
  '[frown]': [-125, -150],
  '[stupid]': [-301, -150],
  '[makeup]': [-276, -225],
  '[love]': [-175, -250],
  '[touch]': [0, -75],
  '[pollution]': [-251, -25],
  '[mask]': [-275, -275],
  '[waiting]': [-126, -100],
  '[hug]': [-150, -200],
  '[double]': [-276, -150],
  '[heart]': [-75, -200],
  '[crown]': [-201, -125],
  '[fire]': [-50, -100],
  '[666]': [0, -25],
  '[prickekheart]': [-75, -125],
  '[explosion]': [-50, -75],
  '[shit]': [-101, -25],
  '[camera]': [-100, -200],
  '[rose]': [-75, -275],
  '[fade]': [-100, -100],
  '[brick]': [-200, -250],
  '[cheers]': [-175, -175],
  '[pray]': [-276, 0],
  '[knee]': [-201, -100],
  '[knife]': [-251, 0],
  '[redpacket]': [-25, -50],
  '[latern]': [-251, -175],
  '[banger]': [-51, 0],
  '[fireworks]': [-301, -125],
  '[gold]': [-50, -250],
  '[money]': [-276, -75],
  '[balloon]': [-276, -175],
  '[dogfood]': [-50, -200],
  '[like]': [-251, -75],
  '[Hi]': [-250, -250],
  '[welcome]': [-125, -225],
  '[leftfist]': [-151, -75],
  '[tightfist]': [-176, -100],
  '[loveu]': [-150, -225],
  '[muscle]': [-150, -275],
  '[nail]': [-276, -25],
  '[sour]': [-226, -50],
  '[shiba]': [-251, -225],
  '[lion]': [-301, -175],
  '[dragon]': [-25.5, -25],
  '[dog]': [-276, -100],
  '[kitty]': [-50, -275],
  '[cat]': [-25, -225],
  '[mouse]': [-176, -75],
  '[nolook]': [-25, -150],
  '[nolisten]': [-226, -200],
  '[nospeak]': [-25, -175],
  '[pig]': [-126, -25],
  '[pignose]': [-101, -50],
  '[pigfoot]': [-25, -75],
  '[alpaca]': [-200, -225],
  '[microphone]': [-301, -50],
  '[dance]': [-100, -150],
  '[cake]': [-301, -25],
  '[lipstick]': [-226, -125],
  '[watergun]': [-251, -125],
  '[airdrop]': [0, -225],
  '[gamepad]': [-50, -175],
  '[hole]': [-301, -225],
  '[mirror]': [-75, -250],
  '[minus]': [-151, -125],
  '[cryLaugh]': [-125, -250],
  '[nice]': [-100, -250],
};

const stickers = Object.keys(stickerPositionMap);

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 438px;
  max-height: 320px;
  margin: -12px -16px;
  padding-left: 8px;
  overflow: auto;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 45px;
    cursor: pointer;
    &:hover {
      background: #aaa2;
    }
    > span {
      background-image: url('${stickersImage}');
      background-size: 326px 325px !important;
      width: 25px !important;
      height: 25px !important;
    }
  }
`;

export { stickersImage, stickerPositionMap, stickers };

export default KwaiStickerPicker;
